import React from 'react';

import TrplsTable from '../../common/TrplsTable/TrplsTable';
import { getUrlParameter } from '../../utils';

export default () => {
  const settings = {
    concept: getUrlParameter('id'),
    title: '',
  };

  return <TrplsTable hideEditUiBtn settings={settings} />;
};
